import React from 'react';
import { ICustomizableElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { HeaderSectionStyled } from './styles';

interface Props extends ICustomizableElement {
  children: React.ReactNode;
}

export const HeaderSection: React.FC<Props> = ({ className, children }) => {
  return <HeaderSectionStyled className={className}>{children}</HeaderSectionStyled>;
};
